import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {WarehouseTransferService} from 'app/blocks/service/api/warehouse-transfer.service';
import {Resource} from 'app/constants/resource';
import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {IWarehouseTransfer, WarehouseTransfer} from 'app/blocks/model/inventory-movement.model';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class WarehouseTransferResource extends AbstractEntityResource<IWarehouseTransfer> {
    constructor(warehouseTransferService: WarehouseTransferService, router: Router) {
        super(
            Resource.WAREHOUSE_TRANSFERS,
            warehouseTransferService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.WAREHOUSE_TRANSFERS, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.WAREHOUSE_TRANSFERS),
            (entity?) => new WarehouseTransfer(entity),
            (entity) => entity.documentRef,
            'store'
        );
    }
}
